import { graphql } from '../../../client/gql';

export const ForeignSyncMetasFieldsDocument = graphql(`
  fragment ForeignSyncMetasFields on Query {
    foreignSyncMetas(where: { syncSource: "planung" }) {
      __typename
      foreignRefId
      globalSubject
      ignore
      syncTarget {
        ... on Subject {
          uuid
          __typename
        }
        ... on Class {
          uuid
          __typename
        }
        ... on ClassGroup {
          uuid
          __typename
        }
        ... on Group {
          uuid
          __typename
        }
        ... on Profile {
          uuid
          __typename
        }
        ... on Division {
          uuid
          __typename
        }
      }
    }
  }
`);

export const CreateForeignSyncMetaDocument = graphql(`
  mutation BpCreateForeignSyncMetaDocument($input: [ForeignSyncMetaCreateInput!]!) {
    createForeignSyncMetas(input: $input) {
      foreignSyncMetas {
        __typename
        foreignRefId
        globalSubject
        ignore
        syncTarget {
          ... on Subject {
            uuid
            __typename
          }
          ... on Class {
            uuid
            __typename
          }
          ... on ClassGroup {
            uuid
            __typename
          }
          ... on Group {
            uuid
            __typename
          }
          ... on Profile {
            uuid
            __typename
          }
          ... on Division {
            uuid
            __typename
          }
        }
      }
    }
  }
`);

export const UpdateForeignSyncMetaDocument = graphql(`
  mutation BpUpdateForeignSyncMetaDocument($update: ForeignSyncMetaUpdateInput!, $where: ForeignSyncMetaWhere!) {
    updateForeignSyncMetas(update: $update, where: $where) {
      foreignSyncMetas {
        __typename
        foreignRefId
        globalSubject
        ignore
        syncTarget {
          ... on Subject {
            uuid
            __typename
          }
          ... on Class {
            uuid
            __typename
          }
          ... on ClassGroup {
            uuid
            __typename
          }
          ... on Group {
            uuid
            __typename
          }
          ... on Profile {
            uuid
            __typename
          }
          ... on Division {
            uuid
            __typename
          }
        }
      }
    }
  }
`);
